import { createFileRoute } from '@tanstack/react-router';
import type { ReactElement } from 'react';
import { z } from 'zod';

import { RecordInsightViews } from '~/features/insights/os/insight-views';

/** One of a record's insights changed by asking (board dashboard-os-record-edit), or in the one insight editor with `by=hand`. */
const search = z.object({ by: z.enum(['hand']).optional() });

function EditorRoute(): ReactElement {
  const { recordId, cardId } = Route.useParams();
  const { by } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <RecordInsightViews
      key={`${recordId}-${cardId}`}
      recordId={recordId}
      cardKey={cardId}
      by={by ?? null}
      onBy={(next) => void navigate({ search: next === null ? {} : { by: next } })}
    />
  );
}

export const Route = createFileRoute('/_app/records/$recordId/insights/$cardId/edit')({ validateSearch: search, component: EditorRoute });
